'use client'

import { Validation } from '@vinted/web-ui'
import { FieldError } from 'react-hook-form'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const RequiredValidation = ({
  error,
  type = 'required',
  testId,
}: {
  error?: FieldError
  type?: 'required' | 'catalog_rules_required' | 'terms_of_use_required'
  testId?: string
}) => {
  const translate = useTranslate('business.pro_integrations_application.form.validation')

  if (error?.type !== 'required') {
    return null
  }

  return <Validation theme="warning" text={translate(type)} testId={testId} />
}

export default RequiredValidation
